import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { ReglesGestionState } from './state';

export const getters: GetterTree<ReglesGestionState, RootState> = {
    isActif(state): boolean {
        return state.actif;
    },
    isPanneauOuvert(state): boolean {
        return state.panneauOuvert;
    },
    getCleMiseEnAvant(state): string | null {
        return state.cleMiseEnAvant;
    },
};
